import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
 
 

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
 
 import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ComponentsModule } from './components/components.module';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
import { TokenRefreshInterceptor } from './core/interceptor/token-refresh.interceptor';

@NgModule({
  declarations: [AppComponent],
 
  imports: [
    BrowserModule,
    HttpClientModule, 
    IonicStorageModule.forRoot(), // <— necessario se KvService inietta Storage
    IonicModule.forRoot(),
    AppRoutingModule,
  ComponentsModule, 
   
    ServiceWorkerModule.register('combined-sw.js', { enabled: environment.production })
    // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenRefreshInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
